<template>
  <div id="sleep-graph">
    <mu-card class="line-graph" style="padding: 0">
      <mu-card-text>
        <mu-flexbox>
          <mu-flexbox-item>
            <div class="graph-nav">
              <mu-icon-button
                :disabled="graphIsLoading"
                @click.native="dateBackward"
                icon="chevron_left"
              ></mu-icon-button>
            </div>
          </mu-flexbox-item>
          <mu-flexbox-item align="center" grow="5">
            <div class="mediumTitle" v-text="visualDate.fromDate + ' - ' + visualDate.toDate"></div>
          </mu-flexbox-item>
          <mu-flexbox-item shrink="3">
            <div style="float:right" slot="default" class="graph-nav">
              <mu-icon-button
                :disabled="graphIsLoading || visualDate.toDateIsToday"
                @click.native="dateForward"
                icon="chevron_right"
              ></mu-icon-button>
            </div>
          </mu-flexbox-item>
        </mu-flexbox>
      </mu-card-text>

      <div>
        <mu-flexbox v-show="graphIsLoading" justify="center" align="center" v-bind:style="{height: height}">
          <mu-flexbox-item align="center">
            <mu-circular-progress :size="60" align="center" color="#183C45"></mu-circular-progress>
          </mu-flexbox-item>
        </mu-flexbox>
        <mu-flexbox v-if="graphError && !graphIsLoading" justify="center" align="center"
                    v-bind:style="{height: height}">
          <mu-flexbox-item align="center">
            <img src="static/moods/content.svg" width="168"/>
            <h2 style="line-height: 8px;" v-text="$t('message.graphEmpty')"></h2>
            <p v-text="$t('message.graphEmptyExplain')"></p>
          </mu-flexbox-item>
        </mu-flexbox>
      </div>

      <div style="position: relative">
        <graph-point-toggle  v-if="!graphIsLoading && !graphError" :is-disabled="graphIsLoading"></graph-point-toggle>
        <line-graph
          v-show="!graphIsLoading && !graphError"
          :type="graph.type"
          :userId="graph.userId"
          :from-date="graph.fromDate"
          :to-date="graph.toDate"
          @graphLoading="graphLoading"
          @graphLoaded="graphDidLoad"
          @graphFailed="graphDidFail"
          :showPoints="showPoints"
          v-bind:style="{height: height}"
        />
      </div>

      <mu-paper>
        <mu-card-text align="center">
          <mu-chip class="border" @click.native="setDateStep(0)"
                   v-bind:class="{isSelected: (visualDate.dateStep === 0 || visualDate.dateStep === 1) && !isCustomDateMode}">
            {{humanizeDays(0)}}
          </mu-chip>
          <mu-chip class="border" @click.native="setDateStep(7)"
                   v-bind:class="{isSelected: visualDate.dateStep === 7 && !isCustomDateMode}">
            {{humanizeDays(7)}}
          </mu-chip>
          <mu-chip class="border" @click.native="setDateStep(30)"
                   v-bind:class="{isSelected: visualDate.dateStep === 30 && !isCustomDateMode}">
            {{humanizeDays(30)}}
          </mu-chip>
          <mu-chip class="border" @click.native="setDateStep(360)"
                   v-bind:class="{isSelected: visualDate.dateStep === 360 && !isCustomDateMode}">
            {{humanizeDays(360)}}
          </mu-chip>
          <mu-chip class="border" @click.native="showCustomDate()" v-bind:class="{isSelected: isCustomDateMode}">
            {{$t('message.labelCustomDate')}}
          </mu-chip>
        </mu-card-text>
      </mu-paper>

      <mu-paper v-if="isCustomDateMode">
        <mu-card-text>
          <mu-row gutter style="height: 100%">
            <mu-col width="100" desktop="50" tablet="50">
              <mu-row gutter>
                <mu-col width="50" desktop="50" tablet="50">
                  <mu-date-picker
                    icon="date_range"
                    :hintText="$t('message.labelFromDate')"
                    :okLabel="$t('message.okText')"
                    :cancelLabel="$t('message.cancelText')"
                    :dateTimeFormat="dateFormat"
                    format="DD-MM-YYYY"
                    v-model="customDate.fromDate"
                    :maxDate="maxDate"
                    fullWidth
                  ></mu-date-picker>
                </mu-col>
                <mu-col width="50" desktop="50" tablet="50">
                  <mu-date-picker
                    :hintText="$t('message.labelToDate')"
                    :okLabel="$t('message.okText')"
                    :cancelLabel="$t('message.cancelText')"
                    :dateTimeFormat="dateFormat"
                    format="DD-MM-YYYY"
                    v-model="customDate.toDate"
                    :maxDate="maxDate"
                    fullWidth
                  ></mu-date-picker>
                </mu-col>
              </mu-row>
              <mu-row>
                <mu-col width="100" desktop="100" tablet="100" align="right">
                  <mu-flat-button @click.native="hideCustomDate" :label="$t('message.discardText')"></mu-flat-button>
                  <mu-raised-button
                    @click.native="applyCustomDate()"
                    :label="$t('message.applyText')"
                    primary>
                  </mu-raised-button>
                </mu-col>
              </mu-row>
            </mu-col>
          </mu-row>
        </mu-card-text>
      </mu-paper>
    </mu-card>
  </div>
</template>
<script>

  import dateFormat from '../../../../helpers/DatePickerManager'
  import {LineGraph} from '../../Graph'
  import graphMixin from '../../../../mixins/GraphMixin'
  import GraphRequestAborter from '../../../../mixins/GraphRequestAborter'
  import GraphPointToggle from "../../Graph/graph-point-toggle";
  import ServiceTrackingTypes from "../../ServiceTrackingTypes/ServiceTrackingTypes";

  let fromDate = moment().startOf('month');
  let toDate = moment().endOf('month');

  export default {
    name: "sleep-line-graph",
    mixins: [graphMixin, GraphRequestAborter],
    components: {
      ServiceTrackingTypes,
      GraphPointToggle,
      LineGraph
    },
    props: {
      userId: {
        type: Number
      },
      height: {
        type: String,
        default: "284px"
      }
    },
    data() {
      let self = this;
      return {
        selectedService: 'LCP',
        isCustomDateMode: false,
        graphIsLoading: true,
        graphError: false,
        graphErrorObject: {},
        dateFormat: dateFormat,
        maxDate: moment.utc().endOf('year').format('DD-MM-YYYY'),
        visualDate: {
          toDateIsToday: false,
          dateStep: 30,
          fromDate: fromDate.format('Do MMM YY'),
          toDate: toDate.format('Do MMM YY')
        },
        graph: {
          type: 'sleep',
          userId: self.userId,
          fromDate: fromDate.format('YYYY-MM-DD'),
          toDate: toDate.format('YYYY-MM-DD')
        },
        customDate: {
          fromDate: "",
          toDate: ""
        },
      }
    }
  }
</script>
<style lang="less" scoped>
  @bgBranding: #183A43;
  #sleep-graph {
    .border {
      color: @bgBranding;
      background: transparent;
      border: 1px solid @bgBranding;
      &:hover {
        color: white;
        background: fade(@bgBranding, 75%)
      }
    }

    .graph-nav button {
      color: @bgBranding;
    }

    .graph-nav button.disabled {
      color: fade(@bgBranding, 28%) !important;
    }
    .mu-text-field-label {
      color: @bgBranding;
    }
    .mu-text-field-focus-line {
      background-color: @bgBranding;
    }
    .mu-menu-item-wrapper.active {
      color: @bgBranding !important;
    }
    .mu-card-header-title {
      padding-right: 0;
    }
    @media (max-width: 480px) {
      .whiteTitle {
        font-size: 14px !important;
      }
    }
    .trackingPadding {
      padding-top: 16px;
      padding-bottom: 16px;
    }
    .isSelected {
      font-weight: bold;
      background: @bgBranding;
      color: white;
    }
  }


</style>



// WEBPACK FOOTER //
// LineGraph.vue?485380f9